<template>
    <transition name="modal-fade">
        <div class="modal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-dialog-scrollable modal-dialog-centered modal-xl" role="document">
                <div class="modal-content" style="width: 1140px">
                    <div class="modal-header">
                        <h5 class="modal-title">{{ $t('selectionLimitPackageYears') }}</h5>
                        <button type="button" class="btn-close" data-dismiss="modal" @click="close" aria-label="Close" />
                    </div>
                    <div class="modal-body" >
                        <div class="table-responsive" v-if="this.$parent.currentSelectionLimitPackage.selectionLimitPackageYear.length > 0">
                            <table class="table">
                                <thead>
                                    <tr>
                                        <th scope="col">{{ $t('predictiveYear') }}</th>
                                        <th scope="col">{{ $t('limit') }}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(packageYear, i) in this.$parent.currentSelectionLimitPackage.selectionLimitPackageYear"  class="align-middle" :key="i">
                                        <th scope="row">
                                            <input v-model="packageYear.year" disabled type="text" class="form-control" :id="'year_' + i">
                                        </th>
                                          <th scope="row">
                                            <input v-model="packageYear.limitValue" :disabled="this.$parent.currentSelectionLimitPackage.inputMethod != 'custom'" type="number" class="form-control" :id="'limitValue' + i">
                                        </th>
                                       
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" @click="close" data-dismiss="modal" >
                            {{ $t('close') }}
                        </button>
                        <button type="button" class="btn btn-primary" @click="confirm" >
                            {{ $t('confirm') }}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>

export default {
    name: "SelectionLimitPackageYearDialog",
    methods: {
        close() {
            this.$emit("close");
        },
        confirm() {
            this.$emit("confirm")
        },
    },
    data() {
        return {
            list: [],
            selectedRadio: {}
        };
    }
};
</script>